import { defineComponent as k, inject as m, ref as B, computed as T, createElementBlock as d, openBlock as c, mergeProps as A, unref as a, createElementVNode as D, normalizeClass as f, createCommentVNode as g, renderSlot as b, createTextVNode as P, toDisplayString as $ } from "vue";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/ToggleGroup/toggle-group.js";
import { useOUIAProps as C } from "../../helpers/ouia.js";
import { ToggleGroupDisabledKey as N, ToggleGroupSelectionKey as V } from "./ToggleGroup.vue2.js";
import { isDefined as i } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const j = ["id", "aria-pressed", "aria-label", "disabled"], z = /* @__PURE__ */ k({
  name: "PfToggleGroupItem",
  __name: "ToggleGroupItem",
  props: {
    text: {},
    value: {},
    disabled: { type: Boolean, default: void 0 },
    selected: { type: Boolean, default: void 0 },
    ariaLabel: {},
    buttonId: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["click", "update:selected"],
  setup(y, { emit: I }) {
    const l = y, G = C({ id: l.ouiaId, safe: l.ouiaSafe }), p = I, S = m(N, void 0), t = m(V, void 0), v = B(!1), r = T({
      get() {
        if (i(l.selected))
          return l.selected;
        if (!i(t))
          return v.value;
        const e = l.value ?? l.text;
        return i(e) ? Array.isArray(t.value) ? t.value.includes(e) : t.value === e : !1;
      },
      set(e) {
        if (p("update:selected", e), i(l.selected))
          return;
        if (t === void 0) {
          v.value = e;
          return;
        }
        const o = l.value ?? l.text;
        if (i(o))
          if (Array.isArray(t.value))
            if (e)
              t.value.includes(o) || (t.value = [...t.value, o]);
            else {
              const u = t.value.indexOf(o);
              u >= 0 && t.value.splice(u, 1);
            }
          else e ? t.value = o : t.value = void 0;
      }
    });
    function n(e) {
      p("click", e), r.value = !r.value;
    }
    return (e, o) => (c(), d("div", A(a(G), {
      class: a(s).toggleGroupItem
    }), [
      D("button", {
        id: e.buttonId,
        type: "button",
        class: f([a(s).toggleGroupButton, { [a(s).modifiers.selected]: r.value }]),
        "aria-pressed": r.value,
        "aria-label": e.ariaLabel,
        disabled: e.disabled ?? a(S),
        onClick: o[0] || (o[0] = (u) => n == null ? void 0 : n(u))
      }, [
        e.$slots.icon ? (c(), d("span", {
          key: 0,
          class: f(a(s).toggleGroupIcon)
        }, [
          b(e.$slots, "icon")
        ], 2)) : g("", !0),
        e.$slots.default || e.text ? (c(), d("span", {
          key: 1,
          class: f(a(s).toggleGroupText)
        }, [
          b(e.$slots, "default", {}, () => [
            P($(e.text), 1)
          ])
        ], 2)) : g("", !0)
      ], 10, j)
    ], 16));
  }
});
export {
  z as default
};
